var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5834 1.58333V14.25C20.5834 14.6699 20.4165 15.0727 20.1196 15.3696C19.8227 15.6665 19.42 15.8333 19 15.8333H5.78909L2.61451 18.6151C2.61068 18.6192 2.60636 18.6229 2.60164 18.6259C2.31733 18.8675 1.95641 19.0001 1.58336 19C1.35108 18.9996 1.12172 18.9483 0.911434 18.8496C0.637918 18.7235 0.406503 18.5214 0.244873 18.2672C0.0832418 18.0131 -0.00176254 17.7178 2.77056e-05 17.4167V1.58333C2.77056e-05 1.16341 0.166843 0.76068 0.463775 0.463748C0.760708 0.166815 1.16343 0 1.58336 0H19C19.42 0 19.8227 0.166815 20.1196 0.463748C20.4165 0.76068 20.5834 1.16341 20.5834 1.58333Z",
    fill: "#0052FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.a24f12d0e9e57519527f86c6244e824a.svg";
export { ForwardRef as ReactComponent };